export default "__VITE_ASSET__613eca27__"